import type { Map as MapType, MapLayerMouseEvent } from "maplibre-gl";
import type { MapEventBus } from "../core/MapEventBus";
import type { InteractionHandler } from "./types";
import { LAYERS } from "../layers/constants";

export class PdarsClickHandler implements InteractionHandler {
  readonly name = "pdars-click";
  private map: MapType | null = null;

  initialize(map: MapType, eventBus: MapEventBus): void {
    this.map = map;

    // Click on a PDAR feature (platform, target, or sensor — all share the
    // pdars-layer and the pdar_id property key, see PdarsManager.flushUpdates).
    // Only sensors are selectable via this handler; platform/target clicks
    // are ignored so this stays scoped to PDAR sensor units specifically.
    map.on("click", LAYERS.PDARS, (e: MapLayerMouseEvent) => {
      e.preventDefault();

      if (!e.features || e.features.length === 0) return;

      const feature = e.features[0];
      const pdar_id = feature?.properties?.pdar_id;
      const entity_type = feature?.properties?.entity_type;

      if (pdar_id && entity_type === "sensor") {
        console.log("[PdarsClickHandler] PDAR sensor clicked:", pdar_id);

        eventBus.emit("pdar:clicked", {
          pdar_id,
          properties: feature.properties,
        });
      }
    });
  }

  destroy(): void {
    this.map = null;
  }
}
